(() => {
  const detailsSelector = 'details[data-motion-details]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const activeClosures = new WeakMap();

  const motionDuration = () => {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--motion-normal').trim();
    if (value.endsWith('ms')) return Number.parseFloat(value);
    if (value.endsWith('s')) return Number.parseFloat(value) * 1000;
    return 200;
  };

  const initialize = (details) => {
    if (details.hasAttribute('data-motion-ready')) return;
    details.setAttribute('data-motion-ready', '');
    details.dataset.motionState = details.open ? 'open' : 'closed';
  };

  const cancelClose = (details) => {
    const activeClose = activeClosures.get(details);
    if (!activeClose) return;
    activeClose.cancel();
    activeClosures.delete(details);
  };

  const openDetails = (details) => {
    const content = details.querySelector(':scope > .accordion-motion');
    cancelClose(details);

    if (!details.open) {
      details.open = true;
      details.dataset.motionState = 'closed';
      if (!reducedMotion.matches && content) void content.offsetHeight;
    }

    details.dataset.motionState = 'open';
  };

  const closeDetails = (details) => {
    const content = details.querySelector(':scope > .accordion-motion');
    cancelClose(details);
    details.dataset.motionState = 'closed';

    if (reducedMotion.matches || !content) {
      details.open = false;
      return;
    }

    let timer;
    const finish = () => {
      content.removeEventListener('transitionend', handleTransitionEnd);
      window.clearTimeout(timer);
      activeClosures.delete(details);
      details.open = false;
      details.dataset.motionState = 'closed';
    };
    const cancel = () => {
      content.removeEventListener('transitionend', handleTransitionEnd);
      window.clearTimeout(timer);
    };
    const handleTransitionEnd = (event) => {
      if (event.target === content && event.propertyName === 'grid-template-rows') finish();
    };

    activeClosures.set(details, { cancel });
    content.addEventListener('transitionend', handleTransitionEnd);
    timer = window.setTimeout(finish, motionDuration() + 50);
  };

  document.querySelectorAll(detailsSelector).forEach(initialize);

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    const details = summary?.parentElement;
    if (!details?.matches(detailsSelector) || event.defaultPrevented) return;

    event.preventDefault();
    initialize(details);

    if (details.open && details.dataset.motionState !== 'closed') closeDetails(details);
    else openDetails(details);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(detailsSelector).forEach(initialize);
  });
})();
